// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__AJ1-A","rotation":"Spinner_rotation__0qW3G"};